
export function isAriaHidden(props, key) {
    if (props == undefined) { return false }
    if (Array.isArray(props.ariaHidden)) {
        return props.ariaHidden.includes(key)
    } else {
        return false
    }
}

export function mapAriaHiddenArray(mapDictionary: Record<string, string>, ariaHidden?: string[]) {
    var result : string[] = []
    Object.keys(mapDictionary).forEach( key => {
        let value = mapDictionary[key]
        if (ariaHidden?.includes(key) && value) {
            result.push(value)
        }
    })
    return result
}